import { Moment } from 'moment';

import { Establishment } from './establishment.model';

/**
 * Model for API CustomerAccountLegalItem Model
 */
export class LegalEntity {
  accountId: string;

  id: number;

  /**
   * TODO to delete code === siren
   * Legal entity unique code.
   */
  code: string;

  legalEntityCode: string;

  /**
   * Legal entity name.
   */
  name: string;

  /**
   * Establishments linked to this legal entity.
   */
  establishments: Establishment[];

  /**
   * Commune of legal-entity Headquarters establishment
   */
  commune: string;

  gemforceLegalEntityId: string;

  zipCode: string;

  validityStartDate: Moment;

  validityEndDate: Moment;

  constructor(attributes: Partial<LegalEntity> = {}) {
    Object.assign(this, attributes);
  }
}
